import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UIDWEnroll = {
    name: 'DS in Progress',
    imageUrl: '../../images/DWEnroll.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIDWResult = {
    name: 'DS in Progress',
    imageUrl: '../../images/DWResult.png',
    imageSize: "99%",
    bradius: 20,
  };


export const DWEnroll = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Dark Web Enrollment</b><br/><br/>
      CYRISMA's dark web intelligence services provide awareness of compromised IP addresses 
      or domain names. These 4 major elements are assessed, and any discussion or comments 
      relating to the Domain Name, or breached accounts are available for review: <br/><br/>
      <ol style={{marginLeft: '4em'}}>
      <li>Breach Notification</li>
      <li>The Marketplace</li>
      <li>Forums</li>
      <li>Ransomware</li></ol><br/>
      To make use of this feature, first, go to the Enrollment section, and provide the following information <br/><br/>
      <b>Monitor Name:</b> Enter a name to identify the monitor. <br/>
      <b>Email Notification:</b> Dark web alerts and notifications are sent to this address. <br/>
      <b>Domain Name:</b> Enter the Domain Name of the organization being monitored. <br/>
      <b>IPs to Search:</b> Enter up to two external, public IP addresses of the organization being monitored. <br/>
      <b>Validation Address:</b> The email address of someone authorized to verify ownership of the domain being monitored. <br/><br/>
      Following the submission of the dark web monitor enrollment form, the person 
      listed as the “Validation Address” will receive a Domain Verification Email. 
      Follow the verification link within the email to complete the enrolment. 
      This will launch a browser window confirming successful domain registration. <br/><br/>
      Upon successful enrollment, the initial Dark Web Scan executes. This first scan covers the 
      previous 365 days of potential Dark Web activity for this domain and IP addresses. Any Findings 
      from this initial scan will generate an email notification to the configured notification address. 
      </div>
      <div style={helpimg}>
      <img
        src={UIDWEnroll.imageUrl}
        alt={'Image of ' + UIDWEnroll.name}
        style={{
          width: UIDWEnroll.imageSize,
          borderRadius: UIDWEnroll.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const DWResult = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Dark Web Monitor Result</b><br/><br/>
      Go to <b>Dark Web Monitor Result</b> at any time to see all Dark Web findings. <br/><br/>
      If there is no Dark Web data discovered, then no notification is sent. If the buttons 
      are not clickable, this means no Dark Web data about the configured domain or IPs has been discovered. <br/><br/>
      If there is Dark Web data discovered, the buttons for each category discovered will 
      become active indicating the availability of Dark Web data for that category. <br/><br/>
      Click on any of the buttons to see the dark web detail for that category. <br/><br/>
      <b>Breach Data </b><br/><br/>
      In this section, you can see: <br/>
      <ul style={{marginLeft: '4em'}}>
      <li>The Victim Account </li>
      <li>Source where the compromised records were discovered </li>
      <li>The Discovery Dates of when the records were discovered </li>
      <li>Last Seen: The last date of when the information was last seen. </li></ul><br/>
      <b>Forums </b><br/><br/>
      Open the forums section to view detail discovered about the configured domain or IPs on various Dark Web forums. <br/><br/>
      In cases where the forum detail is in a foreign language, hover over and click to display the translation of the message. <br/><br/>
      <b>Marketplace </b><br/><br/>
      Follow the Marketplace button to view more about what data has been found for sale in dark web marketplaces. <br/><br/>
      <b>Ransomware </b><br/><br/>
      Follow the Ransomware button to view more about any Ransomware discussions that may have been discovered about the configured domain or Ips. 
      </div>
      <div style={helpimg}>
      <img
        src={UIDWResult.imageUrl}
        alt={'Image of ' + UIDWResult.name}
        style={{
          width: UIDWResult.imageSize,
          borderRadius: UIDWResult.bradius,
        }}
      />
      </div>
    </div>
  );
};
